// src/components/menu.js
import store from '@/state/store';

const user = store.getters['auth/loggedInUser'];
console.log('User from store:', user);

export const menuItems = user
    ? [
        {
            id: 1,
            label: 'menuitems.menu.text',
            isTitle: true
        },
        {
            id: 2,
            label: 'menuitems.dashboard.text',
            icon: 'ri-dashboard-line',
            badge: {
                variant: 'success',
                text: 'menuitems.dashboard.badge'
            },
            link: '/'
        },
        user.permissions?.find(e => e.name === 'manage_users')
            ? {
                id: 3,
                label: 'menuitems.systemsetup.text',
                icon: 'ri-settings-5-line',
                link: '',
                subItems: [
                    {
                        id: 5,
                        label: 'menuitems.systemsetup.list.users',
                        link: '/users'
                    },
                    {
                        id: 5, // Note: Duplicate ID, consider fixing (e.g., 6)
                        label: 'menuitems.systemsetup.list.approvers',
                        link: '/approval-setup'
                    },
                    {
                        id: 6,
                        label: 'menuitems.systemsetup.list.departments',
                        link: '/departments'
                    },
                    {
                        id: 7,
                        label: 'menuitems.systemsetup.list.trainingcategory',
                        link: '/categories'
                    }
                ]
            }
            : {},
        user.permissions?.find(e => e.name === 'manage_employees')
            ? {
                id: 8,
                label: 'menuitems.employees.text',
                icon: 'ri-team-line',
                link: '',
                subItems: [
                    {
                        id: 9,
                        label: 'menuitems.employees.list.newemployees',
                        link: '/new-employees'
                    },
                    {
                        id: 10,
                        label: 'menuitems.employees.list.manageemployees',
                        link: '/manage-employees'
                    }
                ]
            }
            : {},


        {
            id: 11,
            label: 'menuitems.trainings.text',
            icon: 'ri-suitcase-2-line',
            link: '',
            subItems: [
                {
                    id: 12,
                    label: 'menuitems.trainings.list.newrecommendation',
                    link: '/new-recommendation'
                },
                {
                    id: 13,
                    label: 'menuitems.trainings.list.recommendations',
                    link: '/recommendations'
                },
                user.permissions?.find(e => e.name === 'create_schedule')
                    ? {
                        id: 14,
                        label: 'menuitems.trainings.list.trainingschedule',
                        link: '/new-schedule'
                    }
                    : {},

                {
                    id: 15,
                    label: 'menuitems.trainings.list.managetrainingschedule',
                    link: '/manage-schedule'
                },

                user.permissions?.find(e => e.name === 'approve_schedule')
                    ? {
                        id: 16,
                        label: 'menuitems.trainings.list.approve-schedule',
                        link: '/approve-schedules'
                    }
                    : {}
            ]
        },

        user.permissions?.find(e => e.name === 'manage_nominations')
            ? {
                id: 23,
                label: 'menuitems.nominations.text',
                icon: 'ri-account-pin-box-line',
                link: '',
                subItems: [
                    {
                        id: 25,
                        label: 'menuitems.nominations.list.managenominations',
                        link: '/manage-nominations'
                    }
                ]
            }
            : {},

        {
            id: 17,
            label: 'menuitems.approved-trainings.text',
            icon: 'ri-calendar-check-line',
            link: '',
            subItems: [
                {
                    id: 19,
                    label: 'menuitems.approved-trainings.list.manageapprovedtrainings',
                    link: '/manage-trainings'
                }
            ]
        },

        {
            id: 20,
            label: 'menuitems.training-archive.text',
            icon: 'ri-archive-line',
            link: '',
            subItems: [
                {
                    id: 21,
                    label: 'menuitems.training-archive.list.trainings',
                    link: '/trainings-archive'
                }
            ]
        },


        {
            id: 26,
            label: 'menuitems.reports.text',
            icon: 'ri-file-list-3-line',
            link: '/reports'
        }
    ].filter(item => Object.keys(item).length > 0) // Remove empty objects
    : [
        // Minimal menu for unauthenticated users
        {
            id: 1,
            label: 'menuitems.menu.text',
            isTitle: true
        },
        {
            id: 2,
            label: 'menuitems.dashboard.text',
            icon: 'ri-dashboard-line',
            link: '/login'
        }
    ];